define('modules/common/filter/responsabile',[], function() {
	var Filter = function($filter) {

		return function(responsabile) {
			if (responsabile) {
				var result = [];

				if (responsabile.ruolo) {
					if (responsabile.ruolo === "avvocato") {
						result.push("Avv.");
					} else {
						result.push(responsabile.ruolo);
					}
				}
				result.push(responsabile.nome);
				return result.join(" ");
			} else {
				return "";
			}

		};

	};
	return ["$filter", Filter];
});
